import React from "react";
import ContactFormPage from "./ContactFormPage";

const EditContact = () => {
  return (
    <>
      <ContactFormPage action="Edit" />
    </>
  );
};

export default EditContact;


